import { IUser } from "../Containers/MainPage/MainPage";

export const getKey = (name: string) => localStorage.getItem(name);
export const setKey = (name: string, value: string) => localStorage.setItem(name, value);
export const getUserMetadata = (token: string | undefined | null) => JSON.parse(atob(token.split(".")[1]));
